"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.USER_STATE = exports.UNSAFE_FILE_EXTS = exports.TEXT_ALIGN = exports.TABS = exports.REASSIGNED_TYPES = exports.NOTIFICATIONS = exports.MSG_SOURCE = exports.MEDIATYPE = exports.LIST_TYPES = exports.FONT_SIZES = exports.FONTS = exports.FILE_ICONS = exports.COLORS = exports.CAMPTYPE = void 0;
var MEDIATYPE = exports.MEDIATYPE = {
  CHAT: 1,
  MAIL: 2,
  TWITTER: 3,
  WHATSAPP: 5
};
var TABS = exports.TABS = {
  HOME: 'HOME',
  TWITTER: 'TWITTER',
  CHAT: 'CHAT',
  MAIL: 'MAIL',
  WHATSAPP: 'WHATSAPP',
  MESSENGER: 'MESSENGER',
  TELEGRAM: 'TELEGRAM'
};
var CAMPTYPE = exports.CAMPTYPE = {
  INBOUND: 0,
  OUTBOUND: 1
};
var NOTIFICATIONS = exports.NOTIFICATIONS = {
  TWITTER: 'tweet',
  CHAT: 'chat',
  MAIL: 'mail'
};
var MSG_SOURCE = exports.MSG_SOURCE = {
  USER: 'USER',
  AGENT: 'AGENT',
  ADMIN: 'ADMIN',
  COACH: 'COACH'
};
var COLORS = exports.COLORS = {
  red: '#FF0000',
  coralred: '#FF4040',
  vividtangerine: '#FF8080',
  evony: '#05060B',
  abbey: '#444548',
  oslogray: '#828385',
  blueribbon: '#0062FF',
  dodgerblue: '#408AFF',
  malibu: '#80B1FF',
  japaneselaurel: '#1FA000',
  apple: '#57B840',
  deyork: '#8FCF80',
  flushorange: '#FF7F00',
  yelloworange: '#FF9F40',
  macaroniandcheese: '#FFBF80'
};
var FONT_SIZES = exports.FONT_SIZES = {
  8: '8px',
  10: '10px',
  12: '12px',
  14: '14px',
  16: '16px',
  18: '18px',
  20: '20px',
  22: '22px'
};
var TEXT_ALIGN = exports.TEXT_ALIGN = {
  left: 'left',
  center: 'center',
  right: 'right'
};
var FONTS = exports.FONTS = {
  Arial: 'Arial, Helvetica, sans-serif',
  Georgia: "Georgia, 'Times New Roman', Times, serif",
  'Times New Roman': "'Times New Roman', Times, serif",
  'Courier New': "'Courier New', Courier, monospace",
  Verdana: 'Verdana, Geneva, Tahoma, sans-serif',
  'Franklin Gothic': "'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif",
  'Comic Sans': "'Comic Sans ms', sans-serif",
  'Arial Narrow': "'Arial Narrow', Verdana, Tahoma, sans-serif",
  'Lucida Sans': "'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif"
};
var LIST_TYPES = exports.LIST_TYPES = ['numbered-list', 'bulleted-list'];
var UNSAFE_FILE_EXTS = exports.UNSAFE_FILE_EXTS = ['gif', 'ade', 'adp', 'apk', 'appx', 'appxbundle', 'bat', 'cab', 'chm', 'cmd', 'com', 'cpl', 'dll', 'dmg', 'exe', 'hta', 'ins', 'isp', 'iso', 'jar', 'js', 'jse', 'lib', 'lnk', 'mde', 'msc', 'msi', 'msix', 'msixbundle', 'msp', 'mst', 'nsh', 'pif', 'ps1', 'scr', 'sct', 'shb', 'sys', 'vb', 'vbe', 'vbs', 'vxd', 'wsc', 'wsf', 'wsh', 'log'];
var USER_STATE = exports.USER_STATE = {
  CHANGE_STATE: 'CHANGE_STATE',
  CALL_OUT: 'CALL_OUT',
  LOGED_OUT: 'LOGED_OUT',
  LOGED_IN: 'LOGED_IN',
  AGENT_READY: 'AGENT_READY',
  NO_AVAILABLE: 'NO_AVAILABLE',
  DIALOG: 'DIALOG',
  MANUAL_CALL: 'MANUAL_CALL',
  WAITING_TRANSFER: 'WAITING_TRANSFER',
  ERROR: 'ERROR',
  CALL_TRANSFER: 'CALL_TRANSFER',
  RINGING: 'RINGING',
  WRAPUP: 'WRAPUP',
  XFER: 'XFER',
  OTHER: 'OTHER',
  EXCLUSIVE_CALLBACK: 'EXCLUSIVE_CALLBACK',
  CHATTING: 'CHATTING',
  READY_PREVIEW: 'READY_PREVIEW',
  ASSISTED: 'ASSISTED',
  DIALOG_WHATSAPP: 'DIALOG_WHATSAPP',
  WHATSAPP: 'WHATSAPP',
  DIALOG_EMAIL: 'DIALOG_EMAIL'
};
var REASSIGNED_TYPES = exports.REASSIGNED_TYPES = {
  BY_AGENT: 'byAgent',
  BY_TIMEOUT: 'byTimeout'
};
var FILE_ICONS_DICTIONARY = {
  pdf: 'pdf',
  xls: 'excel',
  xlsx: 'excel',
  doc: 'document',
  docx: 'document',
  txt: 'document',
  csv: 'csv'
};
var FILE_ICONS = exports.FILE_ICONS = new Proxy(FILE_ICONS_DICTIONARY, {
  get: function get(object, property) {
    return object.hasOwnProperty(property) ? object[property] : 'document';
  }
});


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/utils/constants.js
// module id = 58
// module chunks = 0